<script setup>
import {reactive} from 'vue'
import {Auth, State, clone, go} from '@/paks/vu-app'

const page = reactive({
    existing: null,
    password: null,
    rules: [],
    showPassword: true,
    user: State.auth.user,
})

async function save() {
    await Auth.changePassword(page.existing, page.password)
    go('/')
}
</script>

<template>
    <vu-form :data="page" :save="save" help="/doc/ui/account/password.html" title="Change Your Password" class="page-form ma-5 user-password">
        <input type="hidden" name="username" :value="page.user.email" />
        <v-text-field
            v-model="page.existing"
            class="vcol-12"
            label="Current Password"
            name="current-password"
            type="password"
            autocomplete="current-password"
            :append-icon="page.showPassword ? '$eye' : '$eyeOff'"
            :rules="page.rules.password"
            :type="page.showPassword ? 'text' : 'password'"
            @click:append="page.showPassword = !page.showPassword" />
        <v-text-field
            v-model="page.password"
            autocomplete="new-password"
            class="vcol-12"
            counter
            hint="At least 8 characters"
            name="new-password"
            label="New Password"
            type="password"
            :append-icon="page.showPassword ? '$eye' : '$eyeOff'"
            :rules="page.rules.password"
            :type="page.showPassword ? 'text' : 'password'"
            @click:append="page.showPassword = !page.showPassword" />
        <div class="actions">
            <v-btn size="small" color="primary" type="submit">Save</v-btn>
            <v-btn size="small" color="none" @click="go('/')">Cancel</v-btn>
        </div>
    </vu-form>
</template>


<style lang="scss">
.user-password {
    max-width: 700px;
}
</style>